import uniqid from 'uniqid'
import { useContext } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { LanguageContext } from '../../contexts/language'
import content from '../../portfolio'
import './Skills.css'

const Skills = () => {
  const { language } = useContext(LanguageContext)
  const { skills } = content[language]
  const labels = {
    de: 'Fähigkeiten',
    en: 'Skills'
  }
  
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const [titleRef, titleInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  if (!skills.length) return null

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20
      }
    }
  }

  return (
    <section className='section skills' id='skills'>
      <motion.h2 
        ref={titleRef}
        className='section__title'
        initial={{ opacity: 0, y: -20 }}
        animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        {labels[language]}
      </motion.h2>
      
      <motion.ul 
        ref={ref}
        className='skills__list'
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        {skills.map((skill) => (
          <motion.li 
            key={uniqid()} 
            className='skills__list-item btn btn--plain'
            variants={itemVariants}
            whileHover={{ 
              scale: 1.15,
              rotate: [0, -5, 5, -5, 0],
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              backgroundColor: "var(--clr-primary)",
              color: "var(--clr-bg)",
              transition: { duration: 0.3 }
            }}
            whileTap={{ scale: 0.95 }}
          >
            {skill}
          </motion.li>
        ))}
      </motion.ul>
    </section>
  )
}

export default Skills
